module.exports = __webpack_public_path__ + "static/media/im‫g_project_market_demo.77a92654.png";